import { cn } from '@/lib/utils';
import { useTrips } from '../context/TripsContext';
import { EditableInput } from './EditableInput';

interface EditableTripNameAndDescriptionProps {
  className?: string;
}

export const EditableTripNameAndDescription = ({ className }: EditableTripNameAndDescriptionProps) => {
  const { currentTrip, updateTrip } = useTrips();

  if (!currentTrip) {
    return null;
  }

  const handleNameSave = async (newName: string) => {
    await updateTrip(currentTrip.id, { nickname: newName });
  };

  const handleDescriptionSave = async (newDescription: string) => {
    await updateTrip(currentTrip.id, { description: newDescription });
  };

  return (
    <div className={cn("flex items-center min-w-0 w-full", className)}>
      <EditableInput
        value={currentTrip.nickname}
        onSave={handleNameSave}
        fontSize="text-lg md:text-xl lg:text-3xl font-semibold"
        className="flex-shrink-0"
      />
      <EditableInput
        value={currentTrip.description || ''}
        onSave={handleDescriptionSave}
        placeholder="Put your trip reason here"
        fontSize="text-sm text-muted-foreground"
        className="flex-1 self-end"
      />
    </div>
  );
};
